import React, {Component, createContext} from 'react';
import PropTypes from 'prop-types';
import {withCookies} from 'react-cookie';

const AuthContext = createContext();

const AuthConsumer = AuthContext.Consumer;

class AuthProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuth: this.props.authenticationService.isAuthenticated(this.props.cookies),
            matchMedia: this.props.matchMedia,
            errorMessage: null,
        };
        this.logout = this.logout.bind(this);
        this.authenticateFB = this.authenticateFB.bind(this);
        this.authenticateFormLogin = this.authenticateFormLogin.bind(this);
        this.setMatchesMedia = this.setMatchesMedia.bind(this);
    }

    async authenticateFB(response) {
        const data = await this.props.authenticationService.authenticateFb(response.accessToken, this.props.cookies);

        if (data.errorMessage) {
            this.setState({
                isAuth: this.props.authenticationService.isAuthenticated(),
                errorMessage: data.errorMessage,
                redeemedCampaignCode: data.redeemedCampaignCode || null,
            });
        } else {
            this.setState({
                isAuth: this.props.authenticationService.isAuthenticated(),
                redeemedCampaignCode: data.redeemedCampaignCode || null,
            });
        }

        return data;
    }

    async authenticateFormLogin(formLog) {
        const data = await this.props.authenticationService.authenticateFormLogin(formLog, this.props.cookies);

        if (data.errorMessage) {
            this.setState({
                isAuth: this.props.authenticationService.isAuthenticated(this.props.cookies),
                errorMessage: data.errorMessage,
                redeemedCampaignCode: data.redeemedCampaignCode || null,
            });
        } else {
            this.setState({
                isAuth: this.props.authenticationService.isAuthenticated(this.props.cookies),
                redeemedCampaignCode: data.redeemedCampaignCode || null,
            });
        }

        return data;
    }

    logout() {
        this.props.authenticationService.logout(this.props.cookies);
        this.setState({
            isAuth: this.props.authenticationService.isAuthenticated(this.props.cookies)
        });
    }

    setMatchesMedia(matchMedia) {
        this.setState({matchMedia});
    }

    render() {
        return (
            <AuthContext.Provider value={
                {
                    matchMedia: this.state.matchMedia,
                    isAuth: this.state.isAuth,
                    setMatchesMedia: this.setMatchesMedia,
                    authenticateFB: this.authenticateFB,
                    authenticateFormLogin: this.authenticateFormLogin,
                    logout: this.logout,
                    errorMessage: this.state.errorMessage,
                    redeemedCampaignCode: this.state.redeemedCampaignCode,
                    cookies: this.props.cookies
                }}
            >
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

AuthProvider.propTypes = {
    authenticationService: PropTypes.object.isRequired,
    children: PropTypes.node,
    matchMedia: PropTypes.bool,
    cookies: PropTypes.object,
};

const AuthProviderWithCookies = withCookies(AuthProvider);

export {AuthProviderWithCookies as AuthProvider, AuthConsumer};
